import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from './models/user.model';
import { UserFactory } from './factories/user.factory';
import { EnrichResource } from './resource.service';

@Injectable()
export class UserResource extends EnrichResource<User> {
  protected resource: string = 'users';

  constructor(
    protected httpClient: HttpClient,
    protected userFactory: UserFactory,
  ) {
    super(httpClient, userFactory);
  }

  public activateUser(user: User) {
    let url: string = `${this.resourceUrl()}/${user.id}/activate`;
    return this.httpClient.post(url, null);
  }

  public deactivateUser(user: User) {
    let url: string = `${this.resourceUrl()}/${user.id}`;
    return this.httpClient.delete(url);
  }
}



// WEBPACK FOOTER //
// ./src/app/resources/user.resource.ts